import React from "react";
import GeneralSelect from "../../general_select";
import CreateService from "../../../service/create";
import PopDetail from "../../popdetail";
import {AuthorizationService} from "../../../service/v1/authorization";

export default class SelfRegistration extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            gender:'',
            first_name:'',
            middle_name:'',
            last_name:'',
            email:'',
            phone_number:'',
            organization:'',
        }

        this.submit = this.submit.bind(this)
    }

    submit(){
        let first_name = this.state.first_name
        let middle_name = this.state.middle_name
        let last_name = this.state.last_name
        let organization = this.state.organization
        let phone_number = this.state.phone_number
        let email = this.state.email
        let gender = this.state.gender
        alert('Gender : ' + gender)
        if (first_name.toString()==='' || last_name.toString()===''){
            alert('Firstname and Lastname MUST be filled')
            return
        }
        if (email.toString()==='' || organization.toString()===''){
            alert('Email and Organization MUST be filled')
            return
        }
        AuthorizationService.createStakeholderUser({
            first_name: first_name,
            middle_name: middle_name,
            last_name:last_name,
            organization:organization,
            phone:phone_number,
            email:email,
            gender:gender
        }).then(r  =>{
            //this.props.loadProjects()
            console.log(r);
            PopDetail.dismiss()
        })
    }

    handleChanges=(e)=>{
        this.setState({[e.target.name]:e.target.value})
    }
    render() {
        return(
            <div className={'row'}>

                <div className={'col col-sm-12'} style={{padding:0}}>

                    <table style={{width:'94%',margin:'2%'}}>
                        <tbody>
                        <tr>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                            <td>
                                For stakeholder to access land use planning information, register here and proceed to
                                select the plan and make payment to get access to the selected plan
                            </td>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <table style={{width:'94%',margin:'2%'}}>
                        <tbody>
                        <tr>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                            <td>
                                <input placeholder={'first name'} type={'text'} style={{width:'100%',padding:'8px'}}
                                       name={'first_name'} onChange={this.handleChanges}/>
                            </td>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                        </tr>

                        </tbody>
                    </table>

                    <table style={{width:'94%',margin:'2%'}}>
                        <tbody>
                        <tr>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                            <td>
                                <input placeholder={'middle name'} type={'text'} style={{width:'100%',padding:'8px'}}
                                       name={'middle_name'} onChange={this.handleChanges}/>
                            </td>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                        </tr>

                        </tbody>
                    </table>

                    <table style={{width:'94%',margin:'2%'}}>
                        <tbody>
                        <tr>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                            <td>
                                <input placeholder={'last name'} type={'text'} style={{width:'100%',padding:'8px'}}
                                       name={'last_name'} onChange={this.handleChanges}/>
                            </td>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                        </tr>

                        </tbody>
                    </table>

                    <table style={{width:'94%',margin:'2%'}}>
                        <tbody>
                        <tr>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                            <td>
                                <input placeholder={'email'} type={'text'} style={{width:'100%',padding:'8px'}}
                                       name={'email'} onChange={this.handleChanges}/>
                            </td>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                    <table style={{width:'94%',margin:'2%'}}>
                        <tbody>
                        <tr>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                            <td>
                                <input placeholder={'phone number'} type={'text'} style={{width:'100%',padding:'8px'}}
                                       name={'phone_number'} onChange={this.handleChanges}/>
                            </td>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                        </tr>

                        </tbody>
                    </table>

                    <table style={{width:'94%',margin:'2%'}}>
                        <tbody>
                        <tr>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                            <td>
                                <input placeholder={'Organization / Office'} type={'text'} style={{width:'100%',padding:'8px'}}
                                       name={'organization'} onChange={this.handleChanges}/>
                            </td>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                        </tr>

                        </tbody>
                    </table>

                    <table style={{width:'94%',margin:'2%'}}>
                        <tbody>
                        <tr>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                            <td>
                                <select style={{width:'25%',padding:'8px',backgroundColor:"white",color:'black'}}
                                        onChange={this.handleChanges} name={'gender'}>
                                    <option value={''}> Gender </option>
                                    <option value={'M'}>Male</option>
                                    <option value={'F'}>Female</option>
                                </select>
                            </td>
                            <td style={{width:'20%',padding:'8px'}}>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>

                    <div style={{textAlign:'center',width:'100%',float:'left'}}>
                        <button className={'btn submit'} onClick={this.submit}>
                            <span className={'fa fa-save'}/>Register
                        </button>
                    </div>

                </div>

            </div>
        )
    }
}